<template>
    <v-container class="step-container" v-if="unit && current">
        <c-drop-message
            v-if     = "drag.notAllowed"
            :message ="drag.message"
        />

        <drop class="cut" @drop="onDrop" mode="cut" :accepts-type="onAcceptType">
            <v-row class="no-frame">
                <v-col class="step-first-column">
                    <div class="v-flex w-100">
                        <inc-site-down-switch
                            v-if      = "data.tags.includes('sitedown')"
                            v-model   = "current.unitDown"
                            class     = "mt-0"
                            :readonly = "siteDownEnabled"
                        />
                    </div>
                    <div>
                        <v-switch
                            v-model       = "current.unitDownAlert"
                            class         = "step-site-down mt-0 pt-1 pb-1"
                            :class        = "current.unitDownAlert===true?'step-site-down-active':''"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            :color        = "current.unitDownAlert?'error':'primary'"
                            :ripple       = "false"
                            @change       = "onUnitDownAlert"
                        >
                            <template v-slot:label>
                                <span :class="current.unitDownAlert===true?'step-site-down-active':''">Stillstand im IOT Dashboard</span>
                            </template>
                        </v-switch>
                    </div>

                    <inc-status
                        v-model = "current.status"
                        :items  = "step.status"
                        @change = "onStatusChanged"
                        class   = "mt-6"
                    />

                    <v-row class="no-frame">
                        <v-col class="no-frame col-6 pr-2">
                            <msd-users
                                v-model     = "incident.responsible"
                                :background = "fileEntryFieldBackground"
                            />
                        </v-col>
                        <v-col class="no-frame col-6 pl-2">
                            <f-date-picker
                                label   = "inc.edit.common.executionDate"
                                v-model = "current.executionDate"
                                :rules  = "[requiredOnProceccingScheduledRule]"
                                class   = "w-100"
                            />
                        </v-col>
                    </v-row>

                    <v-text-field
                        v-model           = "data.reporter"
                        :label            = "$t('inc.edit.general.reporter')"
                        :background-color ="fileEntryFieldBackground"
                        autocomplete      = "off"
                        autocorrect       = "off"
                        autocapitalize    = "off"
                        spellcheck        = "false"
                    />

                    <inc-processing-interval
                        :data          = "data"
                        :status        = "current.status"
                        :background    = "fileEntryFieldBackground"
                        @start-changed = "validate"
                        @end-changed   = "validate"
                    />

                    <v-text-field
                        v-model           = "incident.externalId"
                        :label            = "$t('inc.edit.general.external')"
                        :background-color = "fileEntryFieldBackground"
                        autocomplete      = "off"
                        autocorrect       = "off"
                        autocapitalize    = "off"
                        spellcheck        = "false"
                    />

                    <f-date-picker
                        label             = "inc.edit.general.offerDate"
                        v-model           = "incident.offerDate"
                        :background-color = "fileEntryFieldBackground"
                        class             = "w-100"
                    />

                    <inc-unit-down-interval
                        v-if          = "data.tags.includes('sitedown')"
                        :unitdata     = "current"
                        :status       = "current.status"
                        @endchanged   = "onUnitDownEndChanged"
                        @startchanged = "onUnitDownStartChanged"
                    />

                    <c-v-spacer />
                </v-col>
                <v-col class="step-middle-column">
                    <v-switch
                        v-if           = "data.tags.includes('invoice')"
                        v-model        = "data.invoice"
                        :label         = "$t('inc.edit.common.invoice')"
                        class          = "mt-0 pt-1 pb-1"
                        :class         = "fileEntryFieldBackground"
                        @change        = "onInvoice"
                        hide-details

                    />

                    <v-textarea
                        v-model        = "current.description"
                        :rules         = "[requiredRule]"
                        :label         = "$t('inc.edit.general.description')"
                        :rows          = "rows"
                        class          = "mt-4"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        no-resize
                        counter
                    />

                    <v-textarea
                        v-model        = "current.cause"
                        :label         = "$t('inc.edit.general.cause')"
                        :rows          = "rows"
                        class          = "mt-3"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        no-resize
                        counter
                    />
                    <v-textarea
                        v-model        = "current.measure"
                        :rules         = "[requiredOnTerminationRule]"
                        :label         = "$t('inc.edit.general.measure')"
                        :rows          = "rows"
                        class          = "mt-3"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        no-resize
                        counter
                    />
                    <c-v-spacer />
                </v-col>
                <v-col class="step-middle-column">
                    <v-row
                        class="no-frame"
                        style="margin-top: 42px!important;"
                        v-if="data.tags.includes('components')"
                    >
                        <v-col class="no-frame">
                            <inc-components
                                v-model     = "current.components"
                                :site       = "unit"
                                :status     = "current.status"
                                :incident   = "incident"
                                :height     = "250"
                                style       = "border-radius: 5px 0 5px 5px; margin-top: -1px"
                                :warranties = "warrenties (unit.id)"
                                @input      = "onComponents"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="no-frame mt-11  lm-border pa-2" style="min-height: 200px">
                        <v-col class="no-frame">
                            <v-row class="no-frame ">
                                <inc-manufacturer
                                    v-model     = "data.manufacturer"
                                    :rules      = "[requiredOnTerminationRule]"
                                    :background = "fileEntryFieldBackground"
                                    @changed    = "onManufacturer"
                                />
                            </v-row>
                            <v-row class="no-frame">
                                <c-contact-select
                                    v-if        = "data.manufacturer"
                                    v-model     = "data.contactIds"
                                    label       = "Kontakte"
                                    class       = "w-100"
                                    :company-id = "data.manufacturer ? data.manufacturer.id : null"
                                    :incident   = "incident"
                                    :index      = "index"
                                    :status     = "current.status"
                                    :background = "fileEntryFieldBackground"
                                    @sendmail   = "onSendmail"
                                />
                            </v-row>
                        </v-col>
                    </v-row>
                    <c-v-spacer />
                </v-col>
                <v-col class="step-last-column" style="padding-right: 5px">
                    <crm-journal
                        :incident = "incident"
                        @front    ="onJournalFront"
                        @saved    = "success=true"
                        style     = "margin-top: -10px"
                    />
                </v-col>
            </v-row>
        </drop>
    </v-container>
</template>

<script>

import {Drop} from "vue-easy-dnd"

import Core from "@/modules/core/service/Core";
import Inb from "@/modules/inb/service/Inb";
import Inc from "@/modules/inc/service/Inc.js";
import FDatePicker from "@/modules/core/components/utils/FDatePicker.vue";
import IncSiteDownSwitch from "@/modules/inc/steps/components/common/IncSiteDownSwitch.vue";
import IncStatus from "@/modules/inc/steps/components/common/IncStatus.vue";
import MsdUsers from "@/modules/msd/user/components/controls/MsdUsers.vue";
import IncManufacturer from "@/modules/inc/steps/components/common/IncManufacturer.vue";
import CrmJournal from "@/modules/crm/components/main/CrmJournal.vue";
import IncProcessingInterval from "@/modules/inc/steps/components/common/IncProcessingInterval.vue";
import CVSpacer from "@/modules/core/components/utils/CVSpacer.vue";
import IncComponents from "@/modules/inc/steps/components/common/IncComponents.vue";
import Mail from "@/modules/inc/mail/service/Mail";
import CContactSelect from "@/modules/msd/company/contact/components/controlls/CContactSelect.vue";
import IncUnitDownInterval from "@/modules/inc/steps/components/common/IncUnitDownInterval.vue";
import StepMixin from "@/modules/inc/steps/components/mixins/StepMixin";
import CDropMessage from "@/modules/inc/steps/components/common/CDropMessage.vue";

export default {
    name: "IncIssue",

    mixins: [
        StepMixin
    ],

    components: {
        CDropMessage,
        IncUnitDownInterval,
        CContactSelect,
        IncComponents,
        CVSpacer,
        IncProcessingInterval,
        IncManufacturer,
        MsdUsers,
        IncStatus,
        FDatePicker,
        CrmJournal,
        IncSiteDownSwitch,
        Drop
    },

    props: {
        incident: {
            required: true,
            type: Object,
            default: function () {
                return {
                    responsible: null,
                    beginDate  : null,
                    endDate    : null
                }
            }
        },

        data: {
            required: true,
            type: Object,
            default: function () {
                return {
                    executionDate: null,
                    reporter     : null,
                    contactIds   : [],
                    current      : null,
                    data         : [
                        {
                            clipboardEntry : null
                        }
                    ]
                }
            }
        },

        changes: {
            type: Function,
        },

        step: {
            required: true,
            type: Object,
        },

        index: {
            required: true,
            type    : Number
        },
    },

    data: () => ({
        drag: {
            notAllowed: false,
            message   : null
        },

        refresh: 0,
        details: false,
        valid  : false,
        rows   : 7,
        selectWarranty: null,
        selectedContacts: null,
        event: null,
    }),


    created() {
        this.freeze = JSON.stringify(this.data);
        this.$bus.$on(this.$events.drag.end, this.onDragend);
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.drag.end, this.onDragend);
    },

    mounted() {
        this.form = this.$parent;
        this.$nextTick(() => {
            this.form.validate();
            this.initBase();
        });
    },

    computed: {
        issueInvoice () {
            return this.incident.data[this.index+1];
        },

        repair () {
            return this.incident.data[this.index+2];
        },

        repairInvoice () {
            return this.incident.data[this.index+3];
        },

        siteDownEnabled () {
            return !(!this.incident.siteDownEnd || this.incident.siteDownEnd.length === 0);
        },

        fileEntryFieldBackground () {
            return Inc.style.fileEntryFieldBackground(this.data);
        },
   },

    methods: {
        _validate() {
            if (!this.unit) {
                return;
            }

            this.current.valid = this.form.validate();
            let valid = true;
            this.data.collection.forEach(data => {
                if (!data.valid) {
                    valid = false;
                }
            })

            this.valid = valid;
        },

        /**
         * Sets the given unit als new context for the processing step. The visibility of other processing steps and
         * will be adopted to the given unit.
         *
         * @param unit the new unit context.
         */
        _setContext(unit) {
            this.unit = unit;
            this.setVisibility();

            if (this.event && this.event.id === "standstill") {
                this.current.unitDown = true;
                this.current.unitDownAlert = true;
                this.current.unitDownBegin = this.event.data.received;
                this.current.description = "Stillstandsmeldung vom LiftGuardian."
                this.event = null;
            }
        },

        /**
         * Checks if the current processing step in the current context is terminated.
         * @returns true, if the processing step is terminated, false otherwise.
         */
        _isTerminated() {
            return this.current.status.type === 'T';
        },

        _status () {
            if (!this.current) {
                return null;
            }

            return this.current.status;
        },

        /**
         * Force an update of relevat componets. E.g. when the list of assigned sites changes.
         */
        _forceUpdate() {
            this.setVisibility();
            this.freeze = JSON.stringify(this.data);
            this.refresh++;
        },

        _unitStepStatus(unit) {
            const current = this.data.collection.find(s => s.unit.id === unit.id);
            if (!current) {
                return null;
            }

            return current.valid ? "success" : "error";
        },

        _unitDownResolved (event) {
            this.event = event;
            this.confirmUnitDownResolved = true;
        },

        _unitDownCreate (event) {
            this.event = event;
        },

        /**
         * Validate the processing step and informs the main dialog about a possible change.
         */
        validate() {
            return this.$nextTick().then(() => {
                this._validate();
                return Promise.resolve();
            })
        },

        /**
         * Checks whether a message can be attached to the current processing step.
         * @param dragData the message
         * @return true, if the message can be attached to the step.
         */
        onAcceptType(dragData) {
            if (!(dragData instanceof Object) || dragData.type === "dms-document") {
                return;
            }

            const accept = Inc.clipboard.accept(dragData, this.incident, [{
                message: "INCIDENT",
                incident: null
            }, {
                message: "DEFAULT",
                incident: null
            }, {
                message: "VERIFICATION",
                incident: null
            }, {
                message: "ORDER",
                incident: null
            }, {
                message: "WORKREPORT",
                incident: null
            }, {
                message: "IMAGE",
                incident: null
            },{
                message: "CORRESPONDENCE",
                incident: null
            },{
                message : "REPAIR",
                incident: null
            }, {
                message : "ORDERPLACEMENT",
                incident: null
            }], true, true);

            this.drag.notAllowed = !accept.valid;
            this.drag.message    = this.$t(accept.message);

            this.drag.notAllowed = !accept.valid;
            this.drag.message    = this.$t(accept.message);

            return accept.valid;
        },

        /**
         * Attaches a message to the processing step.
         * @param event the drag'n drop element that contains the message,
         */
        onDrop(event) {
            console.log("drop", event)
            switch (event.data.type) {
                case 'clipboard':
                    Inc.clipboard.paste (this, event.data.data.id, event.data.data.unit, this.incident.id, this.changes());
                    break;
                case 'inbox':
                    Inb.attach(this, event.data.data.id, this.incident.id, this.step, null, true, (message) => {
                        this.$emit("refresh", message);
                    });
            }
        },

        onDragend () {
            this.drag.notAllowed = false;
        },

        onInvoice() {
            this.issueInvoice.visible = this.data.invoice;
            this.validate().then(() => {
                this.$emit("save");
            });
        },

        onComponents(components) {
            this.data.components = components;
            this.validate().then(() => {
                Core.fire.validated(this);
            })
        },

        onManufacturer() {
            this.data.contactIds = [];
        },

        getMail() {
            return Mail.initialize(this.incident.sites, this.index, this.data, this.current, this.incident, this.step);
        },

        onSendmail(mail) {
            mail.step = this.step.id;
            this.$emit("sendmail", mail);
        },

        /**
         * Checks whether an end date has been set for the unit. If so, the corresponding "unit down" switch will be
         * automatically reset.
         *
         * @param value the current value of the unit down interval.
         */
        onUnitDownEndChanged(value) {
            if (value) {
                if (this.current.unitDown) {
                    this.current.unitDown = false;
                }
            } else {
                if (this.current.unitDownBegin) {
                    this.current.unitDown = true;
                }
            }
        },

        onUnitDownStartChanged (value) {
            if (value && !this.current.unitDownEnd && !this.current.unitDown) {
                this.current.unitDown = true;
            }

            this.validate();
        },

        requiredRule(value) {
            return Core.rule.required(value);
        },

        requiredOnTerminationRule(value) {
            if (!this.current) {
                return true;
            }

            if (value instanceof Object) {
                return Core.rule.requiredOnTermination(value.id, this.current.status);
            }

            return Core.rule.requiredOnTermination(value, this.current.status);
        },


        requiredOnProceccingScheduledRule(value) {
            if (!this.current) {
                return true;
            }

            return Core.rule.requiredOnStatus(value, this.current.status, Inc.status.proceccingScheduled);
        },

        warrenties(unitId) {
            if (!this.incident.warrenties) {
                return [];
            }

            return this.incident.warrenties.find(w => w.unit.id === unitId);
        },

        setVisibility() {
            if (!this.repair) {
                return;
            }

            if (this.current) {
                this.repair.visible = Inc.status.terminatedWithRepair.includes(this.current.status.id);
                if (!this.repair.visible) {
                    this.repairInvoice.visible = false;
                } else {
                    this.repairInvoice.visible = this.repair.invoice;
                }
            }
        },

        onUnitDownAlert () {
            if (this.current.unitDownAlert)  {
                this.current.unitDown = true;
            }
        },
    }
}
</script>

<style scoped>

</style>
